import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { APP_ENVIRONMENT } from '@app/shared/tokens';

import { catchError, of, tap } from 'rxjs';

@Component({
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        ReactiveFormsModule,

        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatLabel,
        MatDialogTitle,
        MatFormField,
        MatInput,
    ],
})
export class LoginDialogComponent {
    fb = inject(FormBuilder);
    http = inject(HttpClient);
    env = inject(APP_ENVIRONMENT);
    dialogRef = inject(MatDialogRef);

    error = signal<string | null>(null);

    form = this.fb.group({
        username: '',
        password: '',
    });

    onLogin() {
        this.error.set(null);
        return this.http.post(`${this.env.serverUrl}/auth/get-token`, this.form.value).pipe(
            tap(() => {
                this.dialogRef.close(true);
            }),
            catchError((e) => {
                this.error.set(e.error.message);
                return of(false);
            }),
        );
    }
}
